import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

// MUI imports
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";

// Project imports
import PartOne from "./Part1";
import PartTwo from "./Part2";
import PartThree from "./Part3";
import FormCompletionSuccess from "./Part4/FormCompletionSuccess";
import { TrainingCentreRegContext } from "./helperFunctions";

import { tregFetchAllStates, fetchAllActiveSkillsTreg } from "../../Actions";

const steps = [
  {
    icon: "Hello",
    title: "Part One",
    subTitle: "Sections 1 - 3",
  },
  {
    icon: "Hello",
    title: "Part Two",
    subTitle: "Sections 4 - 5",
  },
  {
    icon: "Hello",
    title: "Part Three",
    subTitle: "Sections 6 - 8",
  },
];

const DisplayCurrentFormSection = ({ currentStep }) => {
  switch (currentStep) {
    case 0:
      return <PartOne />;

    case 1:
      return <PartTwo />;

    case 2:
      return <PartThree />;

    case 3:
      return <FormCompletionSuccess />;

    default:
      break;
  }
};

const FormStepper = () => {
  const globalDispatch = useDispatch();
  const trainingCentreRegReducer = (globalState) =>
    globalState.trainingCentreRegReducer;

  const { activeStep, listOfActiveSkills } = useSelector(
    trainingCentreRegReducer
  );

  // stepper data
  const [saveSectionData, setSaveActionData] = useState(false);
  const [pageNavDirection, setPageNavDirection] = useState("");
  const [parsedListOfSkills, setParsedListOfSkills] = useState([]);

  const contextObject = {
    saveSectionData,
    setSaveActionData,
    pageNavDirection,
    setPageNavDirection,
    parsedListOfSkills,
  };

  useEffect(() => {
    globalDispatch(tregFetchAllStates());
    globalDispatch(fetchAllActiveSkillsTreg());
  }, []);

  // parse list of skills to {id, label} format
  useEffect(() => {
    if (listOfActiveSkills.length > 0) {
      let parseResult = [];
      listOfActiveSkills.map((skill) => {
        const newObj = {
          id: skill.id,
          label: skill.name,
        };
        parseResult.push(newObj);
      });
      setParsedListOfSkills(parseResult);
    }
  }, [listOfActiveSkills]);

  return (
    <TrainingCentreRegContext.Provider value={contextObject}>
      <Box sx={{ width: "100%" }}>
        <Stepper activeStep={activeStep}>
          {steps.map((stepInfo) => {
            return (
              <Step key={stepInfo.title}>
                <StepLabel> {stepInfo.title} </StepLabel>
              </Step>
            );
          })}
        </Stepper>

        {/* horizontal line  */}
        <Box sx={{ m: "48px 0 0 0" }}>
          <Divider />
          <p style={{ margin: "20px 0 35px 0" }}>
            <i>All fields marked with * are compulsory!</i>
          </p>
        </Box>

        {/* Form Page Content */}
        <DisplayCurrentFormSection currentStep={activeStep} />
      </Box>
    </TrainingCentreRegContext.Provider>
  );
};

export default FormStepper;
